import { render, staticRenderFns } from "./answer-list.vue?vue&type=template&id=6026c8c5&scoped=true"
import script from "./answer-list.vue?vue&type=script&lang=js"
export * from "./answer-list.vue?vue&type=script&lang=js"
import style0 from "./answer-list.vue?vue&type=style&index=0&id=6026c8c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026c8c5",
  null
  
)

export default component.exports